import { gql } from '@apollo/client';

export const UPDATE_PAYMENT_PLAN_INSTALLMENTS = gql`
  mutation updatePaymentPlanInstalments($input: UpdatePaymentPlanInstalmentsInput) {
    updatePaymentPlanInstalments(input: $input) {
      orderInstalments {
        id
      }
    }
  }
`;

export const QUERY_COUNTRIES = gql`
  query QUERY_COUNTRIES($query: String) {
    search(query: $query) {
      totalCount
      edges {
        node {
          ... on Country {
            type: __typename
            slug
            name
            id
          }
        }
      }
    }
  }
`;
